"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCNPJ = exports.isCPF = exports.parsePixKeyTypeSafe = exports.parsePixKeyType = void 0;
const _1 = require(".");
const zod_1 = require("zod");
const parsePixKeyType = (key) => {
    const regexPhone = /\+55[0-9]{2}[0-9]{8,9}/;
    const email = zod_1.z.string().email();
    const { success: isEmail } = email.safeParse(key);
    const uuid = zod_1.z.string().uuid();
    const { success: isUuid } = uuid.safeParse(key);
    if (regexPhone.test(key)) {
        return _1.PixKeyType.PHONE;
    }
    else if (isEmail) {
        return _1.PixKeyType.EMAIL;
    }
    else if (isUuid) {
        return _1.PixKeyType.RANDOM;
    }
    else if ((0, exports.isCPF)(key) || (0, exports.isCNPJ)(key)) {
        return _1.PixKeyType.CPF_OR_CNPJ;
    }
    else {
        throw new Error('Invalid pix key');
    }
};
exports.parsePixKeyType = parsePixKeyType;
const parsePixKeyTypeSafe = (key) => {
    try {
        return (0, exports.parsePixKeyType)(key);
    }
    catch (e) {
        return _1.PixKeyType.INVALID;
    }
};
exports.parsePixKeyTypeSafe = parsePixKeyTypeSafe;
const canBeCpfOrCnpj = (str) => {
    return /^[0-9.\/-]+$/.test(str);
};
const isCPF = (key) => {
    if (!canBeCpfOrCnpj(key))
        return false;
    key = key.replace(/[^\d]+/g, '');
    var r = /^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/;
    if (!key || key.length !== 11 || r.test(key)) {
        return false;
    }
    function validateDigit(digit) {
        var add = 0;
        var init = digit - 9;
        for (var i = 0; i < 9; i++) {
            add += parseInt(key.charAt(i + init)) * (i + 1);
        }
        return (add % 11) % 10 === parseInt(key.charAt(digit));
    }
    return validateDigit(9) && validateDigit(10);
};
exports.isCPF = isCPF;
const isCNPJ = (key) => {
    if (!canBeCpfOrCnpj(key))
        return false;
    var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    key = key.replace(/[^\d]/g, '');
    var r = /^(0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14})$/;
    if (!key || key.length !== 14 || r.test(key)) {
        return false;
    }
    const keyArr = key.split('').map(item => parseInt(item));
    for (var i = 0, n = 0; i < 12; i++) {
        n += keyArr[i] * b[i + 1];
    }
    n = 11 - (n % 11);
    n = n >= 10 ? 0 : n;
    if (parseInt(key[12]) !== n) {
        return false;
    }
    for (i = 0, n = 0; i <= 12; i++) {
        n += keyArr[i] * b[i];
    }
    n = 11 - (n % 11);
    n = n >= 10 ? 0 : n;
    if (parseInt(key[13]) !== n) {
        return false;
    }
    return true;
};
exports.isCNPJ = isCNPJ;
